// extracted by mini-css-extract-plugin
module.exports = {"layout":"page-hero_layout__KqGdX","hero":"page-hero_hero__PGCR7","overlay":"page-hero_overlay__Rou5M"};